module.exports = __webpack_public_path__ + "static/media/Timer.8a0d55bd.gif";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/Timer.gif
// module id = 204
// module chunks = 0